import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { HttpClient } from '@angular/common/http';
import 'firebase/storage';
import { environment } from '../../environments/environment';
import { Observable } from '../../../node_modules/rxjs';
import { AntEnvService } from './ant.env.svc';
import { timestamp } from 'rxjs/operators';

@Injectable()
export abstract class AbsDataService{
    abstract login(email: string, password: string);
}

@Injectable({ providedIn: 'root' })
export class DataService implements AbsDataService {
    
    private headers4Cors = { headers: {'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' } };

    apiUrl: string = environment.apiUrl;
    user: any;
    fullScreen: boolean = false;
    public dsDateParam: any = [];
    public dsCompareDateParam: any = [];

    constructor(
        private http: HttpClient,
        private firebaseAuth: AngularFireAuth,
        private svcAntEnv: AntEnvService
    ) {
        this.user = firebaseAuth.authState;
        this.svcAntEnv.load().subscribe(res=>{
            // console.log('>>>>> ant-env <<<<<');
            // console.log(res);
            if(res.apiUrl != null){
                this.apiUrl = res.apiUrl;
            }
        });
    }
    public getData(): any[] {
        return [ 'Game of Thrones', 'Breaking Bad', 'The Walking Dead' ];
    }
    areaAdd(argArea):Observable<any>{
        var url = `${this.apiUrl}/api/area/create`;
        return this.http.post(url, argArea, this.headers4Cors);
    }
    updateFPImage(argArea):Observable<any>{
        var url = `${this.apiUrl}/api/area/updatefpimage`;
        return this.http.post(url, argArea, this.headers4Cors);
    }
    uploadFPImage(argArea):Observable<any>{
        var url = `${this.apiUrl}/api/data/fpImageUpload`;
        return this.http.post(url, argArea, this.headers4Cors);
    }
    getFPImage(argArea):Observable<any>{
        var url = `${this.apiUrl}/api/data/getFpImage`;
        return this.http.post(url, argArea, this.headers4Cors);
    }
    uploadCSV(argCSV: string,date,startHour,endHour,tzMinute):Observable<any>{
        var url = `${this.apiUrl}/api/data/import/agv/csv/json/${date}/startHour/${startHour}/endHour/${endHour}/timezoneMinute/${tzMinute}`;
        return this.http.post(url, { Param1: argCSV }, this.headers4Cors);
    }
    cacheRebuild(date):Observable<any>{
        var url = `${this.apiUrl}/api/data/stash/hourly/run/${date}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    configAdd(argId, argKey, argValue):Observable<any>{
        var _arg = {
            id: argId, key: argKey, value: argValue
        };
        var url = `${this.apiUrl}/api/config/create`;
        return this.http.post(url, _arg, this.headers4Cors);
    }
    areaDetail(areaId): Observable<any>{
        var url = `${this.apiUrl}/api/area/${areaId}/detail`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    areaList(parentId): Observable<any>{
        var url = `${this.apiUrl}/api/area/list/parent/${parentId}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    areaListAll(): Observable<any>{
        var url = `${this.apiUrl}/api/area/list/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    areaListForDashboard(): Observable<any>{
        var url = `${this.apiUrl}/api/area/list/dashboard/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    areaListForOccupancy(): Observable<any>{
        var url = `${this.apiUrl}/api/area/list/occupancy/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    isBusinessHour():Observable<any>{
        var url = `${this.apiUrl}/api/data/isBusinessHour/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorAdd(argSensor):Observable<any>{
        var url = `${this.apiUrl}/api/sensor/create`;
        return this.http.post(url, argSensor, this.headers4Cors);
    }
    sensorData(areaId, startTimeStr, endTimeStr): Observable<any>{
        var url = `${this.apiUrl}/api/data/area/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataBySensor(areaId, sensorId, startTimeStr, endTimeStr): Observable<any>{
        var url = `${this.apiUrl}/api/data/sensor/${sensorId}/area/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataBySensorAlone(sensorId, startTimeStr, endTimeStr, tzMinute): Observable<any>{
        var url = `${this.apiUrl}/api/data/sensor/${sensorId}/${startTimeStr}/${endTimeStr}/timezoneMinute/${tzMinute}/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataBySensorCC(areaId, sensorId, startTimeStr, endTimeStr): Observable<any>{
        var url = `${this.apiUrl}/api/data/cc/sensor/${sensorId}/area/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataBySensorAloneCC(sensorId, startTimeStr, endTimeStr, tzMinute): Observable<any>{
        var url = `${this.apiUrl}/api/data/cc/sensor/${sensorId}/${startTimeStr}/${endTimeStr}/timezoneMinute/${tzMinute}/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataBySensorAloneByFrequencyMinute(sensorId, startTimeStr, endTimeStr, tzMinute, frequencyMinute): Observable<any>{
        var url = `${this.apiUrl}/api/data/sensor/${sensorId}/${startTimeStr}/${endTimeStr}/timezoneMinute/${tzMinute}/frequencyMinute/${frequencyMinute}/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataListByFrequencyMinute(areaId, sensorListJson, startTimeStr, endTimeStr, tzMinute, frequencyMinute): Observable<any>{
        var url = `${this.apiUrl}/api/data/sensor/dataList/area/${areaId}/${startTimeStr}/${endTimeStr}/timezoneMinute/${tzMinute}/frequencyMinute/${frequencyMinute}/`;
        //console.log(sensorListJson);
        return this.http.post(url, { token: '', param1: sensorListJson }, this.headers4Cors);
    }
    sensorDataForReportDaily(startTimeStr, endTimeStr): Observable<any>{
        var url = `${this.apiUrl}/api/data/sensor/all/report/daily/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataImportHourly(sensorId, timestampStr, inValue, outValue): Observable<any>{
        var url = `${this.apiUrl}/api/data/import/sensorData/hourly/${sensorId}/${timestampStr}/${inValue}/${outValue}/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataLastData(): Observable<any>{
        var url = `${this.apiUrl}/api/data/sensor/lastData/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataRaw(sensorId, startTimeStr, endTimeStr, tzMinute): Observable<any>{
        var url = `${this.apiUrl}/api/data/sensor/${sensorId}/raw/${startTimeStr}/${endTimeStr}/timezoneMinute/${tzMinute}/`;
        //console.log(url);
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorRemove(argSensor):Observable<any>{
        var url = `${this.apiUrl}/api/sensor/delete`;
        return this.http.post(url, argSensor, this.headers4Cors);
    }
    sensorUpdate(argSensor):Observable<any>{
        var url = `${this.apiUrl}/api/sensor/update`;
        return this.http.post(url, argSensor, this.headers4Cors);
    }
    login(email: string, password: string): Promise<firebase.default.auth.UserCredential> {
        return this.firebaseAuth.signInWithEmailAndPassword(email, password);
        // .then(res=>{
        //     console.log('Success');
        // }).catch(err => {
        //     console.log('Something went wrong: ' + err.message);
        // });
    }
    resetPassword(email: string) {
        return this.firebaseAuth.sendPasswordResetEmail(email);
    }
    templateCreate(argTemplate):Observable<any>{
        var url = `${this.apiUrl}/api/template/create`;
        return this.http.post(url, argTemplate, this.headers4Cors);
    }
    templateDelete(argTemplate):Observable<any>{
        var url = `${this.apiUrl}/api/template/delete`;
        return this.http.post(url, argTemplate, this.headers4Cors);
    }
    templateList(templateType):Observable<any>{
        var url = `${this.apiUrl}/api/template/list/type/${templateType}`;
        return this.http.post(url, {}, this.headers4Cors);
    }
    templateUpdateSubjectBody(argTemplate):Observable<any>{
        var url = `${this.apiUrl}/api/template/update/subjectBody`;
        return this.http.post(url, argTemplate, this.headers4Cors);
    }
    userAdd(arg): Observable<any>{
        var url = `${this.apiUrl}/api/user/create/`;
        return this.http.post(url, arg, this.headers4Cors);
    }
    userConfigGet(userId, code): Observable<any>{
        return this.http.post(`${this.apiUrl}/api/user/config/get`, {userId:userId, param1: code}, this.headers4Cors);
    }
    userConfigSet(userId, code, value): Observable<any>{
        return this.http.post(`${this.apiUrl}/api/user/config/set`, {userId:userId, param1: code, param2: value}, this.headers4Cors);
    }
    userDelete(arg): Observable<any>{
        var url = `${this.apiUrl}/api/user/delete/`;
        return this.http.post(url, arg, this.headers4Cors);
    }
    userUpdateFullNameAndRole(arg): Observable<any>{
        var url = `${this.apiUrl}/api/user/update/fullNameAndRole/`;
        return this.http.post(url, arg, this.headers4Cors);
    }
    userList(): Observable<any>{
        var url = `${this.apiUrl}/api/user/list/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }

    userListByCustomPort(port:any): Observable<any>{
        var arrApiUrlSegment = this.apiUrl.split(':');
        var firstSegment = arrApiUrlSegment[0];
        var secondSegment = arrApiUrlSegment[1];
        var thirdSegment = port;
        var newApiUrl = firstSegment+":"+secondSegment+":"+thirdSegment;
        console.log(newApiUrl);
        var url = `${newApiUrl}/api/user/list/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }

    alertTypeList(): Observable<any>{
        var url = `${this.apiUrl}/api/pushnotilog/alertTypeList/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    logout() {
        this.firebaseAuth.signOut();
    }
    // signUp(email: string, password: string): Promise<firebase.default.auth.UserCredential> {
    //     return this.firebaseAuth.createUserAndRetrieveDataWithEmailAndPassword(email, password);
    // }
    usageAdd(argUsage):Observable<any>{
        var url = `${this.apiUrl}/api/Usage/Create`;
        //console.log("url is "+url);
        //console.log(argUsage);
        return this.http.post(url, argUsage, this.headers4Cors);
    }
    sessionAdd(argSession):Observable<any>{
        var url = `${this.apiUrl}/api/user/session/add`;
        return this.http.post(url, argSession, this.headers4Cors);
    }
    sessionUpdate(argSession):Observable<any>{
        var url = `${this.apiUrl}/api/user/session/update`;
        return this.http.post(url, argSession, this.headers4Cors);
    }
    checkSession(argSession):Observable<any>{
        var url = `${this.apiUrl}/api/user/session/check`;
        return this.http.post(url, argSession, this.headers4Cors);
    }
    usageListByDate(startDate, endDate, name, actionCode): Observable<any>{
        var url = `${this.apiUrl}/api/usage/list/`;
        return this.http.post(url, { StartDate: startDate,EndDate: endDate, Name: name, ActionCode: actionCode }, this.headers4Cors);
    }
    usageListByDateChart(startDate, endDate, name, actionCode): Observable<any>{
        var url = `${this.apiUrl}/api/usage/chartlist/`;
        return this.http.post(url, { StartDate: startDate,EndDate: endDate, Name: name, ActionCode: actionCode }, this.headers4Cors);
    }
    lastLoginTime(): Observable<any>{
        var url = `${this.apiUrl}/api/usage/lastLoginTimelist/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    getDwellTimeData(timestamp): Observable<any>{
        var url = `${this.apiUrl}/api/data/getdwelltime/${timestamp}/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    getDwellTimeDataLastWeek(timestamp): Observable<any>{
        var url = `${this.apiUrl}/api/data/getdwelltimeLastWeek/${timestamp}/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    addDwellTime(startTime, endTime, areaId): Observable<any>{
        var url = `${this.apiUrl}/api/data/dwelltime/${areaId}/${startTime}/${endTime}/`;        
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    isShowDTD(areaId): Observable<any>{
        var url = `${this.apiUrl}/api/data/isdwelltime/${areaId}/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    hourlyDwellTimeData(startTime, endTime, areaId): Observable<any>{
        var url = `${this.apiUrl}/api/data/gethourlydwelltime/${areaId}/${startTime}/${endTime}/`;
        //console.log(url);
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    locationSetUp(areaId, sensorId,x,y): Observable<any>{
        var url = `${this.apiUrl}/api/locationsetup/create/${areaId}/${sensorId}/${x}/${y}/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorLocation(areaId): Observable<any>{
        var url = `${this.apiUrl}/api/locationsetup/getlocationlist/${areaId}/`;
        //console.log(url)
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }

    getTopSensorData(areaId, startTimeStr, endTimeStr): Observable<any> {
        var url = `${this.apiUrl}/api/data/topsensordata/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    getHisTopSensorData(areaId, startTimeStr, endTimeStr, hisStartTimeStr, hisEndTimeStr): Observable<any> {
        var url = `${this.apiUrl}/api/data/histopsensordata/${areaId}/${startTimeStr}/${endTimeStr}/${hisStartTimeStr}/${hisEndTimeStr}`;
        //console.log(url);
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    getAllSensorData(areaId, startTimeStr, endTimeStr): Observable<any> {
        var url = `${this.apiUrl}/api/data/allsensordata/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    getHourlyRangeDwellTimeList(areaId, startTimeStr, endTimeStr): Observable<any> {
        var url = `${this.apiUrl}/api/data/hourlyrangedwelltime/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    getHourlyDwellTimeGH(areaId, dataDate): Observable<any> {
        var url = `${this.apiUrl}/api/data/getdwelltimegh/${areaId}/${dataDate}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }

    alertUpdateByAlertId(id, arg): Observable<any>{
        var url = `${this.apiUrl}/api/alert/update/${id}`;
        //console.log(arg);
        return this.http.post(url, arg, this.headers4Cors);
    }

    alertListByAlertId(alertId): Observable<any>{
        var url = `${this.apiUrl}/api/alert/alertlist/${alertId}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }

    alertListDetails(): Observable<any>{
        var url = `${this.apiUrl}/api/pushnotilog/alertlist/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }

    saveToken(tkn: any, usr: any): Observable<any>{
        //console.log(tkn, " ", usr);
        var url = `${this.apiUrl}/api/pushnotilog/savetoken/${tkn}/${usr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors); 
    }
    
    deleteToken(tkn: any, usr: any): Observable<any>{
        //console.log(tkn, " ", usr);
        var url = `${this.apiUrl}/api/pushnotilog/deletetoken/${tkn}/${usr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors); 
    }

    alertSaveNewRecord(userId, arg): Observable<any>{
        var url = `${this.apiUrl}/api/alert/save/${userId}`;
        //console.log(arg);
        return this.http.post(url, arg, this.headers4Cors);
    }

    alertDelete(id: any): Observable<any>{
        var url = `${this.apiUrl}/api/alert/alertdelete/${id}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
}
